/**
 * Google Analytics Events Tracking
 * Central service for tracking conversion funnel and user events
 */

/**
 * Track sign up completion event (login success)
 * Conversion step 2: User successfully logs in
 */
export function trackSignUpComplete(userId?: string) {
  if (typeof window === 'undefined') return;

  try {
    const gtag = (window as any).gtag;
    if (!gtag) return;

    gtag('event', 'sign_up', {
      method: 'email',
      ...(userId && { user_id: userId }),
    });
  } catch (error) {
    console.error('Failed to track sign up event:', error);
  }
}

/**
 * Track chat message sent event
 * Conversion step 3: User actively uses Chatbot feature
 */
export function trackChatMessageSent(messageLength?: number) {
  if (typeof window === 'undefined') return;

  try {
    const gtag = (window as any).gtag;
    if (!gtag) return;

    gtag('event', 'chat_message_sent', {
      ...(messageLength && { message_length: messageLength }),
    });
  } catch (error) {
    console.error('Failed to track chat message event:', error);
  }
}

/**
 * Track image generation event
 * Conversion step 3: User actively uses Image Generator feature
 */
export function trackImageGenerated(
  model?: string,
  generationTimeMs?: number
) {
  if (typeof window === 'undefined') return;

  try {
    const gtag = (window as any).gtag;
    if (!gtag) return;

    gtag('event', 'image_generated', {
      ...(model && { model }),
      ...(generationTimeMs && { generation_time_ms: generationTimeMs }),
    });
  } catch (error) {
    console.error('Failed to track image generation event:', error);
  }
}

/**
 * Track feature page visit
 * Optional: Track when user visits AI feature pages
 */
export function trackFeaturePageView(featureName: 'chatbot' | 'image_generator') {
  if (typeof window === 'undefined') return;

  try {
    const gtag = (window as any).gtag;
    if (!gtag) return;

    gtag('event', 'view_item', {
      items: [
        {
          item_name: featureName,
          item_category: 'ai_feature',
        },
      ],
    });
  } catch (error) {
    console.error('Failed to track feature page view:', error);
  }
}
